import { actionTypes } from "./actionTypes.js";

/*---------------------------
| Actions (Action Creators)
---------------------------*/
export const setIsReadyForDownload = isReadyForDownload => {
    return {
        type: actionTypes.ASDL_SET_IS_READY_FOR_DOWNLOAD,
        isReadyForDownload: isReadyForDownload
    };
};
export const setAttributionRequired = isRequired => {
    return {
        type: actionTypes.ASDL_SET_ATTRIBUTION_REQUIRED,
        isRequired: isRequired
    };
};
export const setAttributionIsVisible = isVisible => {
    return {
        type: actionTypes.ASDL_SET_ATTRIBUTION_IS_VISIBLE,
        isVisible: isVisible
    };
};
export const setAttributionCopied = isCopied => {
    return {
        type: actionTypes.ASDL_SET_ATTRIBUTION_COPIED,
        isCopied: isCopied
    };
};
export const setShowSpeechBubble = showSpeechBubble => {
    return {
        type: actionTypes.ASDL_SET_SHOW_SPEECH_BUBBLE,
        showSpeechBubble: showSpeechBubble
    };
};
export const setPurchaseType = purchaseType => {
    return {
        type: actionTypes.ASDL_SET_PURCHASE_TYPE,
        purchaseType: purchaseType
    };
};
